import { ReactComponent as CloseDialog } from 'assett/icons/close_dialog_icon.svg';
import { ReactComponent as DownloadSlim } from 'assett/icons/download_arrow_slim.svg';
import useDialogDownloadOther from 'hooks/DialogDownloadOther.hook';
import { useFileOpener } from 'hooks/downloader.hook';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Dialog, IconButton, Stack, Typography } from 'styles';
import { useTranslation } from 'utils/translations';

const DialogDownloadOther = () => {
	const fileOpener = useFileOpener();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { open } = useSelector((store: RootState) => store.hooks.downloadOther);

	const { claimData: claim } = useSelector((store: RootState) => store.claim);

	const { others } = claim.attachments;

	const downloadOtherDialog = useDialogDownloadOther();

	const handleClose = () => {
		downloadOtherDialog.close();
	};

	const handleDownloadOther = (uuid: string, fileName: string) => {
		const url = `${process.env.REACT_APP_API_URL}/attachments/other/${uuid}/content`;
		fileOpener({ url, fileName });
	};

	return (
		<Dialog
			title={tClientLabels('dialog.downloadOther.title')}
			open={open}
			onClose={handleClose}
			variant="dialog"
			close={
				<IconButton disableRipple onClick={handleClose}>
					<CloseDialog />
				</IconButton>
			}
			actions={<></>}
			events={false}
			type=""
		>
			<Stack gap={'32px'}>
				{others.map(att => (
					<Stack
						key={att.uuid}
						direction={'row'}
						justifyContent={'space-between'}
						alignItems={'center'}
					>
						<Typography variant="caption" color={theme => theme.palette.grey2.main}>
							{att.fileName}
						</Typography>
						<IconButton
							color="inherit"
							onClick={() => handleDownloadOther(att.uuid, att.fileName!)}
						>
							<DownloadSlim />
						</IconButton>
					</Stack>
				))}
			</Stack>
		</Dialog>
	);
};

export default DialogDownloadOther;
